import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class BringozTableChartComponent implements IController {
  data: any;
  limit: any;
  offset: any;
  columnIndexWide: any;

  tableChart: any;

  constructor(private $filter) {
  }

  $onInit() {

    if (this.data) {
      this.translateLabels(this.data);
    }

    // Table Chart
    this.tableChart = {
      type: 'Table',
      data: this.data,
      formatters: {
        date: [{
          columnNum: 0,
          pattern: "dd/MM/yyyy"
        }]
      },
      options: {
        width: '100%',
        alternatingRowStyle: false,
        cssClassNames: {
          headerRow: 'headerRow',
          tableRow: 'tableRow',
          headerCell: 'headerCell',
          tableCell: 'tableCell',
          hoverTableRow: 'hoverTableRow',
          selectedTableRow: 'selectedTableRow '
        },
        // legend: 'none',
        colors: ['#c5c5c5'],
        animation: {
          startup: true,
          duration: 2000,
          easing: "inAndOut"
        }
      }
    };

  };

  $onChanges(changes) {
    if (changes.data && !changes.data.isFirstChange()) {
      if (this.data) {
        this.translateLabels(this.data);
      }
      this.tableChart.data = this.data;
    }
  }

  readyHandler() {
    if (!_.isUndefined(this.columnIndexWide)) {
      this.setDateCell(this.columnIndexWide);
    }
  }

  private translateLabels(data) {
    let numberOfCols = data.getNumberOfColumns();

    if (numberOfCols) {
      _.times(numberOfCols, (index) => {
        var label = data.getColumnLabel(index);
        label = _.startCase(_.toLower(label));
        label = this.$filter('translate')(label);
        data.setColumnLabel(index, label)
      });
    }
  }


  private setDateCell(columnIndex) {
    let container = document.getElementById('bringoz-table-chart');
    let elements = container.getElementsByClassName('headerRow');
    //FIXME - 27/09/2022 Issue with the old code
    // elements[0].childNodes[columnIndex].setAttribute("style", "padding-left:40px !important; padding-right:40px !important;");
  }
}

angular
  .module('bringoz.admin.commons')
  .component('bringozTableChart', {
    bindings: {
      data: '<',
      limit: '<',
      offset: '<',
      columnIndexWide: '<?'
    },
    templateUrl: 'app/modules/commons/components/bringoz-table-chart/bringoz-table-chart.html',
    controller: BringozTableChartComponent
  });
